import dayjs from 'dayjs';
import { ICompany } from 'app/shared/model/company.model';
import { IKpiMain } from 'app/shared/model/kpi-main.model';

export interface IKpiConfScore {
  id?: number;
  value?: number | null;
  company?: ICompany | null;
  kpiMain?: IKpiMain | null;
}

export const defaultValue: Readonly<IKpiConfScore> = {};
